import { ActionType } from 'app/store/actionTypes';
import { ActionsUnion, createAction } from 'app/store/helpers';
import {
  QuotationWithCepikDataSetActionPayload,
  CepikDataSetActionPayload,
} from './actionPayload.interfaces';

export const ShortPathDataActions = {
  setCepikData: (payload: CepikDataSetActionPayload) =>
    createAction(ActionType.SET_CEPIK_DATA, payload),
  setQuotationWithCepikData: (
    payload: QuotationWithCepikDataSetActionPayload
  ) => createAction(ActionType.SET_QUOTATION_WITH_CEPIK_DATA, payload),
  setCepikMergeData: (payload: CepikDataSetActionPayload) =>
    createAction(ActionType.SET_CEPIK_MERGE_DATA, payload),
  clearCepikData: () => createAction(ActionType.CLEAR_CEPIK_DATA),
  clearShortPathData: () => createAction(ActionType.CLEAR_SHORT_PATH_DATA),
  setIsCepikDataRejected: () =>
    createAction(ActionType.SET_CEPIK_DATA_REJECTED),
  setIsCepikDataRejectionModalOpened: (payload: boolean) =>
    createAction(ActionType.SET_IS_CEPIK_DATA_REJECTION_MODAL_OPENED, payload),
  setCepikModalSavingInProgress: (savingInProgress: boolean) =>
    createAction(
      ActionType.SET_CEPIK_MODAL_SAVING_IN_PROGRESS,
      savingInProgress
    ),
  setLastRegistrationNumberWithReturnedData: (payload: string) =>
    createAction(
      ActionType.SET_LAST_REGISTRATION_NUMBER_WITH_RETURNED_DATA,
      payload
    ),
};

export type ShortPathDataActionsType = ActionsUnion<
  typeof ShortPathDataActions
>;
